<div class="loading-overlay">
  <div class="spinner-container">
    <div class="spinner-border" role="status" style="width: 7rem; height: 7rem;">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
